import authHeader from "@/Api/AuthHeader";
import axios from "axios";
const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  actions: {
    async createCompany(data) {
      return await axios.post(URL_API + "addProfileCompany", data, {
        headers: authHeader(),
      });
    },

    async getCompanyLogo() {
      return await axios.get(URL_API + `getCompanyLogo`);
    },

    async getCompany() {
      return await axios.get(URL_API + `profileCompany`);
    },

    updatePercentage(formData) {
      return axios.patch(URL_API + `percentage/${formData.id}`, formData, {
        headers: authHeader(),
      });
    },
  },
};
